import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { InvoiceService } from '../../../../../../../services/invoice.service';
import { HelpersService } from '../../../../../../../services/helpers.service';
import { ProductsService } from '../../../../../../../services/products.service';
import { PaymentService } from '../../../../../../../services/payment.service';
import { AppConfig } from '../../../../../../../app.config';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

const minSearchCharLen = 2;

@Component({
  selector: 'app-rental-reservation-quote',
  templateUrl: './rental-reservation-quote.component.html',
  styleUrls: ['./rental-reservation-quote.component.scss'],
})
export class RentalReservationQuoteComponent implements OnInit {
  @Input() partner;
  @Input() reservation;
  @Input() reservationPaymentHistory;
  @Output() reloadReservation = new EventEmitter();

  public partnerID;
  public loading: boolean = false;
  public invoice: any = {};

  public currencySymbol = '';
  public VATInclusive = true;
  public VATRate = 0.15;
  public allowDiscount = false;
  public editLine: any = {};
  public countryData: any = {};
  public searchResult: any = [];
  public discountType = '';
  public discounts: any = [];
  public lightSpeedDiscounts: any = [];
  public products: any = [];
  public searchExternalFlag: boolean = false;
  public searchExternalValue = '';
  public productSearch: any = '';
  public showAddNew: boolean = false;
  public updatingQuote: boolean = false;
  public showNotePanel: boolean = false;
  public POSName = 'POS';
  public editing: boolean = false;
  public sendingToPOS: boolean = false;
  public qrCodeURL: string = '';
  public discountCode : string = "";
  public addingCoupon : boolean = false;
  public couponError : any = null;
  public reloadPaymentSchedule : boolean = false;
  public hasCouponsSetup = false

  constructor(
    private rentalsService: RentalsService,
    public helpersService: HelpersService,
    private invoiceService: InvoiceService,
    private productsService: ProductsService,
    private paymentService: PaymentService,
    private appConfig: AppConfig,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {}

  ngOnInit() {


    this.loading = true;
    this.partnerID = this.partner.ID;
    this.currencySymbol = this.partner.CurrencySymbol;
    this.VATInclusive = this.partner.VATInclusive;
    this.VATRate = this.partner.VATRate;
    this.allowDiscount = this.partner.AllowDiscount || false;
    this.countryData = this.helpersService.getCountryData();

    if (
      this.reservation.paymentStatusID !== 10 &&
      this.reservation.paymentStatusID != 2 && 
      this.reservation.paymentStatusID != 19 &&
      this.reservation.paymentStatusID != 20
    ) {
      this.paymentService
        .checkPartnerLinkedStripeConnect(this.partner.ID)
        .subscribe((res: any) => {
          if (res.linked) {
            this.qrCodeURL =
              'https://rentals.hubtiger.com/rentals/reservation/' +
              this.reservation.webIdentifier +
              '/payment' +
              (this.appConfig.isDev() ? '?dev=true' : '');
          }
        });
    }

    this.allowDiscount = this.partner.AllowDiscount || false;
    this.discountType =
      this.partner.POSSystemID === 6
        ? 'PERCENTAGE' : 'AMOUNT';
    if (this.discountType === 'PERCENTAGE') {
      this.getLightSpeedDiscounts();
    }

    this.POSName =
      this.partner.POSSystemID === 3
        ? 'POS'
        : this.partner.POSSystemID === 6
          ? 'Lightspeed'
          : this.partner.POSSystemID === 8
            ? 'Xero'
            : this.partner.POSSystemID === 4
              ? 'Sage'
              : this.partner.POSSystemID === 9
                ? 'Shopify'
                : 'POS';

    this.getInvoice();

    if (this.partner.HasCouponsSetup){
      this.hasCouponsSetup = true;
    }
    if (this.partner.POSSystemID === 17)
      this.hasCouponsSetup = false;

  }

  getInvoice() {
    this.loading = true;
    this.rentalsService
      .getRentalReservationInvoice(this.reservation.id)
      .subscribe(
        (invoice) => {
          this.invoice = invoice;
          this.discountCode = invoice.couponCode;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  canSendToPOS() {
    return (
      this.partner.POSSystemID === 3 ||
      this.partner.POSSystemID === 6 ||
      this.partner.POSSystemID === 9 ||
      this.partner.POSSystemID === 12 ||
      this.partner.POSSystemID === 13 ||
      this.partner.POSSystemID === 17 ||
      this.partner.POSSystemID === 19 ||
      this.partner.POSSystemID === 10 ||
      this.partner.POSSystemID === 17
    );
  }

  getLightSpeedDiscounts() {
    this.invoiceService.getDiscounts(this.partner.ID).subscribe((discounts) => {
      this.lightSpeedDiscounts = discounts;
      this.discounts.push({ label: '0%', value: 0 });
      if (discounts && discounts.length > 0) {
        discounts.forEach((discount) => {
          this.discounts.push({
            label: discount.Name,
            value: parseInt(discount.ID),
          });
        });
      }
    });
  }

  canUpdate() {
    if (this.reservation.paymentStatusID == 10 && !(this.invoice?.externalKey == null || this.invoice?.externalKey == "")) return false;
    if (this.reservation.paymentStatusID == 0) return true;
    return true;
  }

  deleteLineItem(lineItem) {
    this.updatingQuote = true;
    this.rentalsService
      .deleteRentalReservationInvoiceLineItem(lineItem.id)
      .subscribe(
        (invoice) => {
          this.updatingQuote = false;
          this.invoice = invoice;
        },
        (err) => {
          this.updatingQuote = false;
        },
      );
  }

  updateLineItem(lineItem) {
    this.editing = false;
    this.updatingQuote = true;

    lineItem.discountOptions = this.lightSpeedDiscounts; //Pass the LS Discount options to the BE so it can calculate the discounts based on this, otherwise we have to make another call to LS slowing things down

    this.rentalsService
      .updateRentalReservationInvoiceLineItem(lineItem)
      .subscribe(
        (invoice) => {
          this.updatingQuote = false;
          this.invoice = invoice;
        },
        (err) => {
          this.updatingQuote = false;
        },
      );
  }

  editLineItem(index) {
    this.editing = true;
    this.invoice.lineItems[index].edit = true;
    this.editLine = this.invoice.lineItems[index];
  }

  notePanelVisible() {
    this.showNotePanel = true;
  }

  notePanelHidden() {
    this.showNotePanel = false;
  }

  updateLineItemNote(lineItem, event) {
    console.log(lineItem);
    event.hide();
    lineItem.LineItemNote = lineItem.lineItemNote;
    this.updateLineItem(lineItem);
  }

  searchProducts(event) {
    this.searchExternalValue = event;
    //this.searchResult = [];

    //Return no resilts for 1 letter... this can slow browser allot. Might want to increase this if too many results get shown
    if (event.query.length < minSearchCharLen) {
      this.searchResult = [];
      return;
    }

    //if the external flag is on, dont try search the cache, go straight to the API as there is logic to direct that to the external products API.
    if (this.searchExternalFlag) {
      this.searchAPI(event);
      return;
    }

    //Try search the SKU type fields 1st
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        //product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (!!product.SystemSKU &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
            -1) ||
        (!!product.ManufacturerSKU &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1) ||
        (!!product.UPC &&
          product.UPC.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.EAN &&
          product.EAN.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.CustomSKU &&
          product.CustomSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
            -1)
      );
    });

    //Use a different search to filter the Name field, this now can search the field with words in any order.
    var nameResults = this.filterList(event.query, this.products);
    if (nameResults && nameResults.length > 0) {
      nameResults.forEach((result) => {
        if (
          results.filter((x) => {
            return x.ID == result.ID;
          }).length === 0
        ) {
          results.push(result);
        }
      });
    }

    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.OriginalUnitPrice = JSON.parse(JSON.stringify(product)).UnitPrice;
      delete product.PartnerID;
      return product;
    });

    if (
      this.partner.AllowExactMatchingOnQuote &&
      results.length === 1 &&
      this.exactMatch(event.query, results[0])
    ) {
      this.addLineItemAuto({ ...results[0] });
    } else if (results.length > 0) {
      this.searchResult = results;
      this.limitResults();
    } else {
      if (
        results.length === 0 &&
        event.query.length > minSearchCharLen &&
        (event.query.length > this.editLine.length - 1 ||
          event.query.length > this.productSearch.length - 1)
      ) {
        //remove last character from the search and try again - Seems certain UPC products barcodes have an extra digit
        event.originalQuery = event.query;
        event.query = event.query.substr(0, event.query.length - 1);
        this.searchProducts(event);
      } else {
        //If the search above returns no records, search the DB
        if (
          event.originalQuery ||
          event.query.length === this.editLine.length - 1 ||
          event.query.length === this.productSearch.length - 1
        ) {
          event.query = event.originalQuery ? event.originalQuery : event.query;
          if (event.originalQuery) {
            delete event.originalQuery;
          }
          this.searchAPI(event);
        } else {
          this.searchResult = [];
        }
      }
    }
  }

  searchAPI(event) {
    if (!this.searchExternalFlag) {
      this.productsService
        .searchProductV2(this.partnerID, event.query)
        .subscribe(
          (results) => {
            if (this.partner.AllowExactMatchingOnQuote && results.ExactMatch) {
              var item = results.products[0];
              this.addLineItemAuto({
                ID: item.ID,
                SKU: item.Description,
                Name: item.Data,
                Quantity: 1,
                Discount: 0,
                DiscountID: 0,
              });
            } else if (
              results.products.length === 0 &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            } else {
              this.searchResult = results.products.map((item) => {
                return {
                  ID: item.ID,
                  SKU: item.Description,
                  Name: item.Data,
                  UnitPrice: item.UnitPrice,
                  UnitPrice_IncludingTax: item.UnitPrice_IncludingTax,
                  Quantity: 1,
                  Discount: 0,
                  DiscountID: 0,
                };
              });
            }
          },
          (err) => {
            if (
              err &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            }
          },
        );
    } else {
      this.productsService
        .searchExternalProduct(this.partnerID, event.query)
        .subscribe(
          (results) => {
            if (
              results.products.length === 0 &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            } else {
              this.searchResult = JSON.parse(
                JSON.stringify(results.products),
              ).map((product) => {
                product.InternalProductID = JSON.parse(
                  JSON.stringify(product),
                ).ID;
                product.ID = 0;
                product.Quantity = 1;
                product.Discount = 0;
                product.DiscountID = 0;
                product.OriginalUnitPrice = JSON.parse(
                  JSON.stringify(product),
                ).UnitPrice;
                delete product.PartnerID;
                return product;
              });
            }
          },
          (err) => {
            if (
              err &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            }
          },
        );
    }
  }

  filterList(q, list) {
    function escapeRegExp(s) {
      return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    const words = q
      .split(/\s+/g)
      .map((s) => s.trim().toLowerCase())
      .filter((s) => !!s);

    const hasTrailingSpace = q.endsWith(' ');
    const searchRegex = new RegExp(
      words
        .map((word, i) => {
          if (words.length === 1) {
            return `(.*${escapeRegExp(word)}.*)`;
          } else {
            return `(?=.*\\b${escapeRegExp(word)})`;
          }
        })
        .join(''),
      'gi',
    );

    var resultList = list.filter((item) => {
      return searchRegex.test(item.Name);
    });

    resultList.forEach((res) => {
      var nameArray = res.Name.split(' ');
      var count = 0;
      nameArray.forEach((name) => {
        if (words.includes(name.toLowerCase())) {
          count += 1;
        }
      });
      res.wordMatch = count;
    });

    resultList = resultList.sort((a, b) => {
      if (a.wordMatch > b.wordMatch) {
        return -1;
      } else if (a.wordMatch < b.wordMatch) {
        return 1;
      } else {
        return 0;
      }
    });

    return resultList;
  }

  limitResults() {
    if (!this.searchExternalFlag) {
      this.searchResult = this.searchResult.filter(function (product) {
        return product.ExternalProductID !== '';
      });
    } else {
      this.searchResult = this.searchResult.filter(function (product) {
        return product.ExternalProductID === '';
      });
    }
  }

  exactMatch(query, item) {
    return (
      query &&
      query.length > 0 &&
      (query === item.SKU ||
        query === item.ManufacturerSKU ||
        query === item.SystemSKU ||
        query === item.EAN ||
        query === item.UPC)
    );
  }

  addLineItemAuto(event) {
    if (event.value) {
      event = event.value;
    }
    if (event.SKU && !event.InternalProductID) {
      this.productsService
        .searchInvoiceProduct(this.partnerID, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.Quantity = 1;
            product.Discount = 0;
            product.DiscountID = 0;
            product.InternalProductID = product.ID;
            product.InvoiceID = this.invoice.id;
            this.updatingQuote = true;
            this.productSearch = '';
            this.rentalsService
              .addRentalReservationInvoiceLineItem(product)
              .subscribe(
                (invoice) => {
                  this.invoice = invoice;
                  this.updatingQuote = false;
                },
                (err) => {
                  this.updatingQuote = false;
                },
              );
          }
        });
    } else {
      let product = event;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.InternalProductID = product.ID;
      product.InvoiceID = this.invoice.id;
      this.updatingQuote = true;
      this.productSearch = '';
      this.rentalsService
        .addRentalReservationInvoiceLineItem(product)
        .subscribe(
          (invoice) => {
            this.invoice = invoice;
            this.updatingQuote = false;
          },
          (err) => {
            this.updatingQuote = false;
          },
        );
    }
  }

  sendToPOS() {
    this.sendingToPOS = true;
    if (
      this.partner.POSSystemID === 3 ||
      this.partner.POSSystemID === 6 ||
      this.partner.POSSystemID === 9
    ) {
      this.rentalsService
        .sendInvoiceToPOS(this.reservation.id, this.invoice.id)
        .subscribe(
          (invoice) => {
            this.invoice = invoice;
            this.reloadReservation.emit({});
            this.sendingToPOS = false;
          },
          (err) => {
            this.sendingToPOS = false;
          },
        );
    } else {
      this.rentalsService
        .sendInvoiceToPOS(this.reservation.id, this.invoice.id)
        .subscribe(
          (invoice) => {
            this.getInvoice();
            this.reloadReservation.emit({});
            this.sendingToPOS = false;
          },
          (err) => {
            this.sendingToPOS = false;
          },
        );
    }
  }

  openPOSURL() {
    switch (this.partner.POSSystemID) {
      case 6:
        if (
          this.partner.POSCustomURL &&
          this.partner.POSCustomURL.indexOf('{{SALEID}}') > -1
        ) {
          window.open(
            this.partner.POSCustomURL.replace(
              '{{SALEID}}',
              this.invoice.externalKey,
            ),
          );
        } else {
          window.open(
            'https://us.merchantos.com/register.php?form_name=load_transaction&transaction_id=' +
              this.invoice.externalKey,
          );
        }
        break;
    }
  }

  reloadReservationLoc(event) {
    this.reloadReservation.emit({});
  }

  updateCouponCode(event){
    this.addingCoupon = true;
    this.couponError = null;

    const couponData = {
      PartnerID : this.helpersService.getPartnerId(),
      AffiliateID : this.reservation.affiliate && this.reservation.affiliate.id ? this.reservation.affiliate.id : null,
      CouponCode: this.discountCode,
      FromDate: this.reservation.fromDate
    }

    this.rentalsService.validateCouponCode(couponData).subscribe(res=>{

      if(this.invoice.hasSplitPayments){
        this.confirmationService.confirm({
          key: 'coupon_confirm',
          header: this.translate.instant('general.confirm'),
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
          message: this.discountCode == "" ? this.translate.instant("bikeshop.coupons.update_split_payments_remove_coupon") : this.translate.instant('bikeshop.coupons.update_split_payments'),
          accept: () => {
            this.applyCouponCode(event);
          },
          reject: ()=>{
            this.discountCode = '';
            event.deactivate();
            this.addingCoupon = false;
          }
        });
      }else{
        this.applyCouponCode(event);
      }

    },err=>{
      this.couponError = err && err.error ? err.error.message : null;
      this.addingCoupon = false;
    })
  }

  applyCouponCode(event){
    const data = {
      DefaultPartnerID : this.reservation.defaultPartnerID,
      ID : this.reservation.id,
      CouponCode: this.discountCode
    }
    this.rentalsService.updateCouponCode(data).subscribe((data)=>{
      this.couponError = null;
      this.getInvoice();
      this.addingCoupon = false;
      event.deactivate();
      this.reloadPaymentSchedule = true;
    },err=>{
      this.getInvoice();
      this.addingCoupon = false;
    });
  }
}
